import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["componentClass", "clsPrefix", "className"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import { elementType } from '../../wui-core/src';
import { WebUI, prefix } from "../../wui-core/src/index.js";
var propTypes = {
  componentClass: elementType
};
var defaultProps = {
  componentClass: 'div',
  clsPrefix: "".concat(prefix, "-modal-body")
};
var ModalBody = (_dec = WebUI({
  name: "modal-body",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalBody, _React$Component);

  var _super = _createSuper(ModalBody);

  function ModalBody() {
    _classCallCheck(this, ModalBody);

    return _super.apply(this, arguments);
  }

  _createClass(ModalBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.componentClass,
          clsPrefix = _this$props.clsPrefix,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, _excluded);

      var classes = {};
      classes["".concat(clsPrefix)] = true;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        className: classNames(className, classes)
      }));
    }
  }]);

  return ModalBody;
}(React.Component)) || _class);
ModalBody.propTypes = propTypes;
export default ModalBody;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/ModalBody.js